
import generateMetaData from '../../features/metaDataGenerator';
import RecorderEmbed from '../preview/RecorderEmbed.vue';

export default {
    name: 'CampaignContribution',
    components: { RecorderEmbed },
    props: {
        campaign: Object | null,
    },
    computed: {
        campaignPath() {
            const queryParams = {};

            if (this.$route.query.name) {
                queryParams.name = this.$route.query.name;
            }

            if (this.$route.query.email) {
                queryParams.email = this.$route.query.email;
            }

            if (this.$route.query.externalID) {
                queryParams.externalID = this.$route.query.externalID;
            }

            const query = Object.keys(queryParams)
                .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key]))
                .join('&');

            if (query) {
                return this.$route.path + '?' + query;
            }

            return this.$route.path;
        },
    },

    head() {
        if (this.campaign.profile) {
            const name = this.campaign.profile.name || '@' + this.campaign.profile.url;
            const image = this.campaign.image || this.campaign.profile.image;

            let title = this.campaign.promptText;

            if (this.campaign.isNPSCampaign) {
                title = this.campaign.NPSQuestion;
            } else if (this.campaign.isCSATCampaign) {
                title = this.campaign.CSATQuestion;
            }

            return generateMetaData({
                url: this.$store.getters['app/getFullyQualifiedURL'],
                applicationNameTitle: name,
                title,
                description: this.$t('share.recording.shareMetadataDescription', { name: name }),
                image: image,
            });
        }
    },
};
